import { Link } from '@/components/ui'
import { cn } from '@/lib/utils'
import { shortId } from '@/lib/format'

/**
 * Consistent treatment for transaction IDs and references: monospace + tabular,
 * shortened for scanability, with the full value on hover (title). Long UUIDs
 * no longer blow out table column widths. Optionally links to a detail page.
 */
export function MonoId({
  value,
  href,
  className,
}: {
  value: string
  href?: string
  className?: string
}) {
  const display = shortId(value)
  const base = cn('font-mono text-xs tabular-nums', className)

  if (href) {
    return (
      <Link
        href={href}
        title={value}
        className={cn(
          base,
          'rounded-sm text-text-strong underline underline-offset-2',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-turquoise',
        )}
      >
        {display}
      </Link>
    )
  }

  return (
    <span title={value} className={cn(base, 'text-text-strong')}>
      {display}
    </span>
  )
}
